import styled from "styled-components"
import Breakpoints from "../../../components/shared/breakpoints"
import { BT } from "../../styles/blog-typography"

// Simple components for each block type
export const Paragraph = styled.p`
  ${BT.sm.body`400`}
  margin-bottom: 24px;

  @media (min-width: ${Breakpoints.md}) {
    ${BT.md.body`400`}
  }
`
export const Bold = styled.strong`
  font-weight: 500;
`
export const Italic = styled.em`
  font-style: italic;
`
export const Underline = styled.u`
  font-style: underline;
`
export const Code = styled.code`
  padding: 4px;
  border-radius: 4px;
  background-color: var(--smoke);
  color: var(--black);
  font-size: 16px;
`
// RichText hyperlinks are all external so we use anchor not <Link/>
export const Hyperlink = styled.a`
  text-decoration: inherit;
  font-weight: 500;
  color: var(--burnt-orange);
`
export const Heading1 = styled.h1`
  ${BT.sm.h1`500`}
  margin: 32px 0 16px 0;
  @media (min-width: ${Breakpoints.md}) {
    ${BT.md.h1`500`}
    margin: 48px 0 24px 0;
  }
`
export const Heading2 = styled.h2`
  ${BT.sm.h2`500`}
  margin: 32px 0 16px 0;
  @media (min-width: ${Breakpoints.md}) {
    ${BT.md.h2`500`}
    margin: 48px 0 24px 0;
  }
`
export const Heading3 = styled.h3`
  ${BT.sm.h3`500`}
  margin: 24px 0 16px 0;
  @media (min-width: ${Breakpoints.md}) {
    ${BT.md.h3`500`}
    margin: 32px 0 16px 0;
  }
`
export const Heading4 = styled.h4`
  ${BT.sm.h4`500`}
  margin: 24px 0 16px 0;
  @media (min-width: ${Breakpoints.md}) {
    ${BT.md.h4`500`}

    margin: 32px 0 16px 0;
  }
`
export const ListItem = styled.li`
  list-style-type: disc;
  margin-left: 32px;
  :last-child {
    margin-bottom: 32px;
  }
  ${Paragraph} {
    margin-bottom: 0;
  }
`

export const StaticImage = styled.img`
  display: block;
  max-width: 100%;
  max-height: 65vh;
  margin: 32px auto;
  @media (min-width: ${Breakpoints.md}) {
    margin: 24px auto;
  }
`
